/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import * as Yup from "yup";
import React, { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import Button from "../Button";
import { FaHome } from "react-icons/fa";
import toast from "react-hot-toast";
import Select from "react-select";
import { axiosInstance } from "../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HiBuildingOffice } from "react-icons/hi2";
import { BsMotherboardFill } from "react-icons/bs";
import countryList from "react-select-country-list";
import { addCart } from "../../redux/slices/Cart";

const AddressCart = ({ submit, setSubmit }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state?.cart?.cart);
  const [orderTypee, setOrderTypee] = useState("delivery");
  const [newAddress, setNewAddress] = useState("");
  const [subtotal, setSubTotal] = useState(0);

  const handleType = (type) => {
    setOrderTypee(type);
    if (type === "pickup") {
      handleRemoveAddress();
    }
    formik.setFieldValue("orderType", type);
  };
  useEffect(() => {
    const total = cart.reduce((acc, item) => {
      return acc + (item?.price * item?.quantity || 0);
    }, 0);

    setSubTotal(total);
  }, [cart]);
  const options = useMemo(() => countryList().getData(), []);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      country: "",
      streetAddress: "",
      apartment: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: "",
      additionalInfo: "",
      paymentMethod: "",
      orderType: orderTypee,
      card_number: "",
      cvv: "",
      expiration_date: "",
    },
    validationSchema: Yup.object().shape(
      orderTypee === "delivery"
        ? {
            firstName: Yup.string().required("First Name is required"),
            lastName: Yup.string().required("Last Name is required"),
            country: Yup.string().required("Country is required"),
            streetAddress: Yup.string().required("Street Address is required"),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            zip: Yup.string().required("Zip is required"),
            phone: Yup.string()
              .required("Phone is required")
              .matches(/^[0-9]+$/, "Phone must be numeric"),
            email: Yup.string()
              .required("Email is required")
              .email("Invalid email address"),
            paymentMethod: Yup.string().required("Payment method is required"),

            card_number: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "Invalid card number",
                    (val) => val && val.replace(/\s/g, "").length === 16
                  )
                  .required("Card number is required"),
              otherwise: (schema) => schema.notRequired(),
            }),

            cvv: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "CVV must be exactly 3 digits",
                    (val) => val && val.length === 3
                  )
                  .required("CVV is required"),
              otherwise: (schema) => schema.notRequired(),
            }),

            expiration_date: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "Expiration date must be 4 digits",
                    (val) => val && val.length === 4
                  )
                  .required("Expiration date is required"),
              otherwise: (schema) => schema.notRequired(),
            }),
          }
        : {
            firstName: Yup.string().required("First Name is required"),
            lastName: Yup.string().required("Last Name is required"),
            email: Yup.string()
              .required("Email is required")
              .email("Invalid email address"),
            paymentMethod: Yup.string().required("Payment method is required"),

            card_number: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "Invalid card number",
                    (val) => val && val.replace(/\s/g, "").length === 16
                  )
                  .required("Card number is required"),
              otherwise: (schema) => schema.notRequired(),
            }),

            cvv: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "CVV must be exactly 3 digits",
                    (val) => val && val.length === 3
                  )
                  .required("CVV is required"),
              otherwise: (schema) => schema.notRequired(),
            }),

            expiration_date: Yup.string().when("paymentMethod", {
              is: (val) => val === "authorize",
              then: (schema) =>
                schema
                  .test(
                    "len",
                    "Expiration date must be 4 digits",
                    (val) => val && val.length === 4
                  )
                  .required("Expiration date is required"),
              otherwise: (schema) => schema.notRequired(),
            }),
          }
    ),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        cart?.map((item, index) => {
          formData.append(`products[${index}][product_id]`, item?.id);
          formData.append(`products[${index}][size]`, item?.size);
          formData.append(`products[${index}][quantity]`, item?.quantity);
          formData.append(`products[${index}][price]`, item?.price);
          item?.product_ingredient_categories?.map(
            (ingredient, ingredientIndex) => {
              formData.append(
                `products[${index}][ingredients][${ingredientIndex}][ingredient_category_id]`,
                ingredient?.categoryId
              );
              formData.append(
                `products[${index}][ingredients][${ingredientIndex}][ingredient_subcategory_id]`,
                ingredient?.subIngredient?.id
              );
            }
          );
          formData.append(
            `products[${index}][total_price]`,
            item?.price * item?.quantity
          );
        });
        formData.append(`sub_total`, subtotal);
        formData.append(
          `total_price`,
          cart[0]?.discount
            ? subtotal - (subtotal * cart[0]?.discount) / 100
            : subtotal
        );
        formData.append(
          `discount_price`,
          cart[0]?.discount ? (subtotal * cart[0]?.discount) / 100 : 0
        );
        if (formik.values.paymentMethod === "authorize") {
          formData.append(`card_number`, values?.card_number);
          formData.append(`cvv`, values?.cvv);
          formData.append(`expiration_date`, values?.expiration_date);
        }
        if (formik.values.orderType === "pickup") {
          formData.append(`order_type`, values?.orderType);
          formData.append(`first_name`, values?.firstName);
          formData.append(`last_name`, values?.lastName);
          formData.append(`email`, values?.email);
          formData.append(`payment_method`, values?.paymentMethod);
        } else {
          formData.append(`first_name`, values?.firstName);
          formData.append(`last_name`, values?.lastName);
          formData.append(`email`, values?.email);
          formData.append(`street_address`, values?.streetAddress);
          formData.append(`phone`, values?.phone);
          formData.append(`country`, values?.country);
          formData.append(`apartment_suit`, values?.apartment);
          formData.append(`state`, values?.state);
          formData.append(`city`, values?.city);
          formData.append(`zip`, values?.zip);
          formData.append(`note`, values?.additionalInfo);
          formData.append(`company_name`, values?.companyName);
          formData.append(`payment_method`, values?.paymentMethod);
        }
        const response = await axiosInstance.post("user/checkout", formData);
        console.log(response, "orderresponse");
        if (response.data.success === true) {
          toast.success(
            response?.data?.message || "Please Check Your Email..!"
          );
          dispatch(addCart([]));
          localStorage.clear();
          navigate("/orderplaced");
          // window.open(response.data.url);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Payment Error!");
        navigate("/orderdecline");
      }
    },
  });
  console.log(formik.values, "values");

  const handleCountry = (countryName) => {
    formik.setFieldValue("country", countryName?.label);
  };

  const handleSetAddress = (address) => {
    setNewAddress(address);
    formik.setFieldValue("firstName", address?.first_name);
    formik.setFieldValue("lastName", address?.last_name);
    formik.setFieldValue("companyName", address?.company_name);
    formik.setFieldValue("country", address?.country);
    formik.setFieldValue("streetAddress", address?.street_address);
    formik.setFieldValue("apartment", address?.apartment_suit);
    formik.setFieldValue("city", address?.city);
    formik.setFieldValue("state", address?.state);
    formik.setFieldValue("zip", address?.zip);
    formik.setFieldValue("phone", address?.phone);
    formik.setFieldValue("email", address?.email);
    formik.setFieldValue("additionalInfo", address?.note);
  };
  const handleRemoveAddress = () => {
    setNewAddress("");
    formik.setFieldValue("firstName", "");
    formik.setFieldValue("lastName", "");
    formik.setFieldValue("companyName", "");
    formik.setFieldValue("country", "");
    formik.setFieldValue("streetAddress", "");
    formik.setFieldValue("apartment", "");
    formik.setFieldValue("city", "");
    formik.setFieldValue("state", "");
    formik.setFieldValue("zip", "");
    formik.setFieldValue("phone", "");
    formik.setFieldValue("email", "");
    formik.setFieldValue("additionalInfo", "");
    formik.setFieldValue("paymentMethod", "");
  };

  const handleFoam = () => {
    if (submit) {
      formik.submitForm();
      setSubmit(false);
    } else {
      setSubmit(false);
    }
  };

  useEffect(() => {
    handleFoam();
  }, [submit]);

  const [allAddress, setAllAddress] = useState([]);
  const getAllAddress = async () => {
    try {
      await axiosInstance.get("user/addressmanagement").then((response) => {
        if (response?.data?.status === true) {
          setAllAddress(response?.data?.address_managements);
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    getAllAddress();
  }, []);

  function formatCardNumber(value) {
    const str = String(value || "");
    return str
      .replace(/\D/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  }

  function formatExpiryDate(value) {
    const str = String(value || "");
    const cleaned = str.replace(/\D/g, "");
    if (cleaned.length <= 2) return cleaned;
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
  }
  return (
    <>
      <div className="row">
        <div
          className="d-flex align-items-center justify-content-between py-3 mb-4"
          style={{ borderBottom: " 1px solid #cd2128" }}
        >
          <p className="mb-0 fw-bold fs-5">Select Address</p>
          <Button
            bg="#CD2128"
            px="5"
            color="#fff"
            onClick={() => navigate("/addaddress")}
            width="auto"
            borderRadius="20px"
            label="New Address"
          />
        </div>

        <div className="row pb-4">
          <div className="col-md-6 col-lg-6 col-xl-6">
            <div className="d-flex align-items-center gap-2">
              <input
                className="p-2 form-check-input"
                type="radio"
                name="orderType"
                value="pickup"
                onChange={() => handleType("pickup")}
                checked={orderTypee === "pickup"}
              />
              <label className="form-check-label" htmlFor="pickup">
                Pickup
              </label>
            </div>
          </div>

          <div className="col-md-6 col-lg-6 col-xl-6 col-12">
            <div className="d-flex align-items-center gap-2">
              <input
                className="p-2 form-check-input"
                type="radio"
                name="orderType"
                value="delivery"
                onChange={() => handleType("delivery")}
                checked={orderTypee === "delivery"}
              />
              <label className="form-check-label" htmlFor="delivery">
                Delivery
              </label>
            </div>
          </div>
        </div>

        {orderTypee === "delivery" &&
          allAddress?.map((e, i) => {
            return (
              <div className="col-md-6">
                <div className="checkout_single_address">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="home">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="home"
                        onChange={() => handleSetAddress(e)}
                        checked={newAddress?.id === e?.id}
                      />

                      <span className="icon d-flex align-items-center gap-2">
                        {e?.type === "office" ? (
                          <HiBuildingOffice size={20} />
                        ) : e?.type === "home" ? (
                          <FaHome />
                        ) : (
                          <BsMotherboardFill size={20} />
                        )}
                        {e?.type}
                      </span>

                      <span className="address pt-0 fw-bold pt-2">
                        {e?.street_address}
                      </span>
                      <span className="address border-0 pt-0">{e?.city}</span>
                    </label>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      <div className="container">
        <div className="row">
          <div className="wow fadeInUp" data-wow-duration="1s">
            <div className="checkout_form">
              <div className="check_form">
                {/* Show all fields for delivery */}
                {orderTypee === "delivery" && !newAddress && (
                  <div className="row mt_30">
                    <div className="col-12">
                      <h5>Billing Address</h5>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-lg-12 col-xl-6">
                        <div className="check_single_form">
                          <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.firstName && (
                            <div className="text-red py-2">
                              {formik.errors.firstName}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-12 col-xl-6">
                        <div className="check_single_form">
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.lastName &&
                            formik.errors.lastName && (
                              <div className="text-red py-2">
                                {formik.errors.lastName}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-12 col-xl-12">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="companyName"
                          placeholder="Company Name (Optional)"
                          value={formik.values.companyName}
                          onChange={formik.handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="reservation_input_single">
                        <Select
                          options={options}
                          name="country"
                          onChange={(e) => handleCountry(e)}
                        />
                        {formik.touched.country && formik.errors.country && (
                          <div className="text-red py-2">
                            {formik.errors.country}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="streetAddress"
                          placeholder="Street Address *"
                          value={formik.values.streetAddress}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.streetAddress &&
                          formik.errors.streetAddress && (
                            <div className="text-red py-2">
                              {formik.errors.streetAddress}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="apartment"
                          placeholder="Apartment, suite, unit, etc. (optional)"
                          value={formik.values.apartment}
                          onChange={formik.handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="city"
                          placeholder="Town / City *"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.city && formik.errors.city && (
                          <div className="text-red py-2">
                            {formik.errors.city}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="state"
                          placeholder="State *"
                          value={formik.values.state}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.state && formik.errors.state && (
                          <div className="text-red py-2">
                            {formik.errors.state}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="zip"
                          placeholder="Zip *"
                          value={formik.values.zip}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.zip && formik.errors.zip && (
                          <div className="text-red py-2">
                            {formik.errors.zip}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone *"
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.phone && formik.errors.phone && (
                          <div className="text-red py-2">
                            {formik.errors.phone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email *"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red py-2">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-12 col-xl-12">
                      <div className="check_single_form mt_30 mb-0">
                        <h5>Additional Information</h5>
                        <textarea
                          name="additionalInfo"
                          cols={3}
                          rows={4}
                          placeholder="Notes about your order, e.g. special notes for delivery"
                          value={formik.values.additionalInfo}
                          onChange={formik.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {orderTypee === "pickup" && !newAddress && (
                  <div className="row mt_30">
                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={formik.values.firstName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.firstName && (
                          <div className="text-red py-2">
                            {formik.errors.firstName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={formik.values.lastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.lastName && formik.errors.lastName && (
                          <div className="text-red py-2">
                            {formik.errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email *"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red py-2">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Show only payment method fields if newAddress is true */}
                <div className="row">
                  {/* <div className="col-md-6 col-lg-4 col-xl-6">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        className="p-2 form-check-input"
                        type="radio"
                        name="paymentMethod"
                        value="paypal"
                        onChange={formik.handleChange}
                        checked={formik.values.paymentMethod === "paypal"}
                      />
                      <label className="form-check-label" htmlFor="paypal">
                        PayPal
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-6 col-12">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        className="p-2 form-check-input"
                        type="radio"
                        name="paymentMethod"
                        value="stripe"
                        onChange={formik.handleChange}
                        checked={formik.values.paymentMethod === "stripe"}
                      />
                      <label className="form-check-label" htmlFor="stripe">
                        Stripe
                      </label>
                    </div>
                  </div> */}

                  <div className="col-md-6 col-lg-4 col-xl-6 col-12">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        className="p-2 form-check-input"
                        type="radio"
                        name="paymentMethod"
                        value="authorize"
                        onChange={formik.handleChange}
                        checked={formik.values.paymentMethod === "authorize"}
                      />
                      <label className="form-check-label" htmlFor="authorize">
                        Authorize
                      </label>
                    </div>
                  </div>
                  {formik.errors.paymentMethod && (
                    <div className="text-red py-2 col-12">
                      {formik.errors.paymentMethod}
                    </div>
                  )}
                </div>

                {formik.values.paymentMethod === "authorize" && (
                  <div className="row mt_30">
                    <div className="col-12">
                      <h5>Pay Now</h5>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-xl-12">
                        <div className="check_single_form">
                          <input
                            type="text"
                            name="card_number"
                            placeholder="Card Number"
                            value={formatCardNumber(formik.values.card_number)}
                            onChange={(e) => {
                              const rawValue = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 16);
                              formik.setFieldValue("card_number", rawValue);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.card_number && (
                            <div className="text-red py-2">
                              {formik.errors.card_number}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-6 col-xl-6">
                        <div className="check_single_form">
                          <input
                            type="text"
                            name="expiration_date"
                            placeholder="MM/YY"
                            value={formatExpiryDate(
                              formik.values.expiration_date
                            )}
                            onChange={(e) => {
                              let cleaned = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 4); // Only 0-9, max 4 digits
                              formik.setFieldValue("expiration_date", cleaned);
                            }}
                            onBlur={formik.handleBlur}
                            maxLength={5} // Includes slash
                            inputMode="numeric" // Shows number keyboard on mobile
                          />
                          {formik.errors.expiration_date && (
                            <div className="text-red py-2">
                              {formik.errors.expiration_date}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-6 col-xl-6">
                        <div className="check_single_form">
                          <input
                            type="text"
                            name="cvv"
                            placeholder="CVV"
                            value={formik.values.cvv}
                            onChange={formik.handleChange}
                            maxLength={3}
                          />
                          {formik.errors.cvv && (
                            <div className="text-red py-2">
                              {formik.errors.cvv}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {newAddress && (
                  <div className="col-12 mt-4">
                    <Button
                      bg="#CD2128"
                      px="5"
                      color="#fff"
                      onClick={handleRemoveAddress}
                      width="auto"
                      borderRadius="20px"
                      label="Custom Address"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressCart;
